export default function addParam(key: string, value: any, overwrite?: boolean) {
    const newSearch = new URLSearchParams(window.location.search);
    if (value === null) {
        newSearch.delete(key);
    } else if (!newSearch.get(key) || overwrite) {
        newSearch.set(key, value.toString());
    }
    window.history.replaceState(null, '', '?' + newSearch.toString());
}
